import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { BirthdateInput } from '../../../BasePersonInputs/Birthdate/BirthdateInput';

export function BirthdateField<TValues extends FieldValues>({
  name,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <BirthdateInput value={value} onChange={onChange} label='Gründungsdatum' />
  );
}
